export const ALLOWED_GENRES = [
  "alternative",
  "blues",
  "cartoon",
  "classical",
  "country",
  "electronic",
  "folk",
  "hip hop",
  "jazz",
  "pop",
  "punk",
  "r&b",
  "rap",
  "reggae",
  "rock",
] as const;

export type AllowedGenre = (typeof ALLOWED_GENRES)[number];

export const ALLOWED_GENDERS = ["male", "female", ""] as const;

export type AllowedGender = (typeof ALLOWED_GENDERS)[number];

export const ALLOWED_SAMPLE_RATES = ["40000", "48000"] as const;

const UNSAFE_TEXT_PATTERN = /[<>"'&\x00-\x1f\x7f]/;

export function isAllowedGenre(value: string): value is AllowedGenre {
  return ALLOWED_GENRES.includes(value.toLowerCase() as AllowedGenre);
}

export function normalizeGenre(value: string): AllowedGenre | null {
  const normalized = value.toLowerCase();

  return isAllowedGenre(normalized) ? normalized : null;
}

export function isSafeModelText(value: string): boolean {
  return (
    value.trim().length > 0 &&
    value.length <= 100 &&
    !UNSAFE_TEXT_PATTERN.test(value)
  );
}

export function genreDropdownOptions(): {
  label: string;
  value: AllowedGenre;
}[] {
  return ALLOWED_GENRES.map((genre) => ({
    label: genre
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" "),
    value: genre,
  }));
}
